//
//
//
//
//
//
//
//
//
//
//

import common from './common.vue';

export default {
  name: 'snake',

  mixins: [common]
};



// WEBPACK FOOTER //
// ./packages/spinner/src/spinner/snake.vue